import React from 'react';
import type { MultiSelectChipsProps } from '../../types';
import { MultiSelectChipsVisibleListItem } from './MultiSelectChipsVisibleListItem';

interface MultiSelectChipsVisibleListProps {
    selectedValues: unknown[];
    visibleCount: number;
    allValuesVisible: boolean;
    getTagProps?: MultiSelectChipsProps['getTagProps'];
    onRemove?: MultiSelectChipsProps['onRemove'];
    readOnly?: boolean;
}

export function MultiSelectChipsVisibleList({
    selectedValues,
    visibleCount,
    allValuesVisible,
    getTagProps,
    onRemove,
    readOnly = false
}: MultiSelectChipsVisibleListProps) {
    return (
        <>
            {selectedValues.map((value, index) => {
                const isHidden = !allValuesVisible && index >= visibleCount;

                return (
                    <MultiSelectChipsVisibleListItem
                        key={index}
                        value={value}
                        index={index}
                        getTagProps={getTagProps}
                        onRemove={onRemove}
                        readOnly={readOnly}
                        allValuesVisible={allValuesVisible}
                        isHidden={isHidden}
                    />
                );
            })}
        </>
    );
}
